import { IFilterContent } from '../lists/listTypes';

export interface ISupplementListState {
    Id: string;
    Enabled: boolean;
    Name: string;
    Description: string;
    FromDate: Date | null;
    ToDate: Date | null;
    IdSupplierHotel: number;
    SupplierHotel: string;
    IdSupplierHotelRoomType: number;
    SupplierHotelRoomType: string;
    IdSupplierHotelMealPlan: number;
    SupplierHotelMealPlan: string;
    IdSupplierHotelRatePlan: number;
    SupplierHotelRatePlan: string;
    IdSupplementCalculationType: number;
    SupplementCalculationType: string;
    IdSupplierTaxCalculationRuleType: number;
    SupplierTaxCalculationRuleType: string;
    SupplierTaxCalculationRuleTypeKey: string;
    IdSupplierTaxCalculationType: number;
    SupplierTaxCalculationType: string;
    SupplierTaxCalculationTypeKey: string;
}

export interface ISupplementDetailState extends ISupplementListState {
    Currency: string;
    IdCurrency: number;
    EffectivePerson: number;
    OnlyAdults: boolean;
    OnlyChildren: boolean;
    Priority: number;
    Amount: number;
    FromAge: number;
    ToAge: number;
}

export interface SupplementFilterState {
    Name: IFilterContent;
    IdSupplierHotel: IFilterContent;
    IdSupplierHotelRoomType: IFilterContent;
    IdSupplierHotelMealPlan: IFilterContent;
    IdSupplierHotelRatePlan: IFilterContent;
    FromDate: IFilterContent;
    ToDate: IFilterContent;
}

export interface ISupplementComplementaryDataOption {
    Id: string;
    Name: string;
    IdCurrency?: number;
    Key?: string;
    Icon: string;
}

export interface IComplementaryDataState {
    data: ISupplementComplementaryDataOption[];
    isLoading: boolean;
    error: string | null;
    count: number;
}

export enum SupplementListViewType {
    TABLE = 'TABLE',
    CALENDAR = 'CALENDAR',
}

export enum SupplementAppliesTo {
    ALL = 'ALL',
    ONLY_ADULTS = 'ONLY_ADULTS',
    ONLY_CHILDREN = 'ONLY_CHILDREN',
}
